import React from 'react'
import { connect } from "react-redux";

import TemplateSelector from './TemplateSelector';
import { selectInvoice, getInvoice } from '../reducers/invoices';

class TemplateBuilderComponent extends React.Component {
  state = {}

  renderComponent(component, prefix, idx) {
    return (<TemplateSelector
      component={component}
      key={prefix + '_' + (component.prop || component.type) + '_' + idx}
      obj={this.props.obj}
      onChangeText={this.props.onChangeText}
      setShowInvoice={this.props.setShowInvoice}
      appointment={this.props.appointment}
      dispatchSelectInvoice={this.props.dispatchSelectInvoice}
      dispatchGetInvoice={this.props.dispatchGetInvoice}
      auth={this.props.auth}
    />);
  }

  render() {
    const components = (this.props.template && this.props.template.components) || [];
    // invoice + document are single-action buttons — surface them in one action
    // bar at the top instead of buried inline. They only do anything once the
    // appointment is saved, so the bar only shows then.
    const isAction = (c) => c.type === 'invoice' || c.type === 'document';
    const isClient = (c) => c.type === 'clientSelect';
    // comments render in the appointment's right rail (above history), not here.
    const isComments = (c) => c.type === 'comments';
    const actions = components.filter(isAction);
    const clients = components.filter(isClient);
    const rest = components.filter((c) => !isAction(c) && !isClient(c) && !isComments(c));
    const saved = !!(this.props.obj && this.props.obj._id);

    return (<div>
      {saved && actions.length > 0 && (
        <div className="apt-actionbar">
          <div className="apt-actionbar-label">Actions</div>
          <div className="apt-actionbar-btns">
            {actions.map((component, idx) => this.renderComponent(component, 'act', idx))}
          </div>
        </div>
      )}
      {/* client selector sits directly under the actions section */}
      {clients.map((component, idx) => this.renderComponent(component, 'client', idx))}
      {rest.map((component, key) => this.renderComponent(component, 'form', key))}
    </div>);
  };
}

const mapStateToProps = state => ({
  auth: state.auth,
  appointment: state.calendar.appointment,
});

const mapDispatchToProps = {
  dispatchSelectInvoice: (id) => selectInvoice(id),
  dispatchGetInvoice: (id, callback) => getInvoice(id, callback),
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateBuilderComponent)
